<template>
<div id="client-circulaire">

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="dataList">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            
        </div>

        <template slot="thead">
            <vs-th sort-key="Item_No" class="table_head_color">Date</vs-th>
            <vs-th sort-key="Name" class="table_head_color">Titre</vs-th>
            <!--<vs-th sort-key="Name" class="table_head_color">Crée par</vs-th>-->
            <vs-th sort-key="Year" class="table_head_color" >Lien</vs-th>          
        </template>

        <template slot-scope="{data}">
            <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td>
                        <p>{{ filterDate(tr.creeLe) }}</p>
                    </vs-td>

                    <vs-td>
                        <p>{{ tr.title }}</p>
                    </vs-td>

                    <!--<vs-td>
                        <p>{{ tr.creePar }}</p>
                    </vs-td>-->
                    <vs-td class="whitespace-no-wrap">                    
                        <button class="button" @click="openUrl(tr.lienCirculaire)"> <feather-icon icon="EyeIcon" class="feather-eye" svgClasses="w-3 h-3" /></button>
                    </vs-td>
                </vs-tr>
            </tbody>
        </template>
    </vs-table>

</div>
</template>

<script>
import circulaireService from "@/http/requests/circulaire/index.js";
import { id } from 'vuejs-datepicker/src/locale';
import moment from 'moment';
export default {
    data() {
        return {
            imgView: require("@/assets/images/portrait/small/eye.svg"),
            itemsPerPage: 10,
            dataList: [],
            popupActiv: false,
        }
    },
    watch: {
        dataList: function () {
            this.$vs.loading.close("#client-circulaire > .con-vs-loading");
        }
    },
    methods: {    
        openUrl(url){
            window.open(url, '_blank');
        }, 
        filterDate(value) {
             if (value) {
                 return moment(String(value)).format('DD/MM/YYYY HH:MM')
             }
        },  
        loadData() {
            try {
                circulaireService.getAll().then(response => {
                    this.dataList = response.data
                })
                this.$vs.loading.close("#client-circulaire > .con-vs-loading");
            } catch {
                this.$vs.loading.close();
                this.$vs.loading.close("#client-circulaire > .con-vs-loading");
                this.$vs.notify({
                    time: 10000,
                    title: "Erreur s'est produite l'ors de la récupération de données",
                    text: "Erreur",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circles"
                });
            }
        }
    },
    computed: {
    },
    created() {
         this.loadData();       
    },
    mounted() {
        this.isMounted = true;
        if (this.$store.state.article.clients.value == null) {
            this.$vs.loading({
                background: this.backgroundLoading,
                type: 'radius',
                container: "#client-circulaire",
                scale: 0.45,
                clickEffect: true
            });
        }
        
    }
}
</script>

<style lang="scss">
#client-circulaire {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;
.button {
  background-color:rgb(40, 199, 111);
  color:white;
  cursor: pointer;
  border-color: aliceblue;
  border-bottom-width: 0px;
  padding: 4px;
}
    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }
}
</style>
